// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?ver=" + "7cda8360df20aece96c2" + "";
};